module.exports = __webpack_public_path__ + "img/thumbnails-2-movie-seat-booking.4771b21c.png";